import './index.css';
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from './pages/Dashboard';
import ProductListPage from './pages/ProductListPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PurchaseOrderPage from './pages/PurchaseOrderPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderDetailPage from './pages/OrderDetailPage';
import DealerProfilePage from './pages/DealerProfilePage';
import Sidebar from './components/Sidebar';
import { UserContextProvider } from './context/DealerProfile';
import MainToast from './components/MainToast';
import PurchaseOrder from './features/purchase/PurchaseOrder';
import { PurchaseOrderProvider } from './features/purchase/hooks/usePurchaseOrder';
import OrderReturn from './pages/OrderReturn';
import FavouriteProductPage from './pages/FavouriteProductPage';
import BillingAdressesPage from './pages/BillingAdressesPage';
import ShippingAddressesPage from './pages/ShippingAdressesPage';
import ReturnHistoryPage from './pages/ReturnHistoryPage';
import ReturnHistoryDetailPage from './pages/ReturnHistoryDetailPage';
import CancelOrderList from './features/order/CancelOrderList';
import ChangeRequestPage from './pages/ChangeRequestPage';

createRoot(document.getElementById("root")).render(
  <UserContextProvider>
    <StrictMode>
      <BrowserRouter basename="/app">

        <div className='h-full w-full flex overflow-hidden'>
          <MainToast />
          <Sidebar />

          <div className='bg-slate-100 flex-1 h-screen overflow-auto p-6 box-border'>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/index.html" element={<Navigate to="/dashboard" />} />

              <Route path="/dashboard" element={<Dashboard />} />
            </Routes>

            <Routes>
              <Route path="/purchase-order" element={<PurchaseOrderPage />} />
              <Route path="/purchase-order/:orderId" element={<PurchaseOrderProvider><PurchaseOrder /></PurchaseOrderProvider>} />
            </Routes>

            <Routes>
              <Route path="/order-history" element={<OrderHistoryPage />} />
              <Route path="/order-history/:orderId" element={<OrderDetailPage />} />
            </Routes>

            <Routes>
              <Route path="/products" element={<ProductListPage />} />
              <Route path="/products/:productId" element={<ProductDetailPage />} />
            </Routes>

            <Routes>
              <Route path="/sales-return" element={<OrderReturn />} />
              <Route path="/sales-return/:orderId" element={<OrderReturn />} />
            </Routes>

            <Routes>
              <Route path="/cancel-order" element={<CancelOrderList />} />
              <Route path="/cancel-order/:orderId" element={<CancelOrderList />} />
            </Routes>

            <Routes>
              <Route path="/return-history" element={<ReturnHistoryPage />} />
              <Route path="/return-history/:orderId" element={<ReturnHistoryDetailPage />} />
            </Routes>

            <Routes>
              <Route path="/profile" element={<DealerProfilePage />} />
            </Routes>

            <Routes>
              <Route path="/favourite-item" element={<FavouriteProductPage />} />
            </Routes>

            <Routes>
              <Route path="/billing-adresses" element={<BillingAdressesPage />} />
              <Route path="/shipping-adresses" element={<ShippingAddressesPage />} />
            </Routes>
            
            <Routes>
              <Route path="/change-request" element={<ChangeRequestPage />} />
            </Routes>
          </div>
        </div>

      </BrowserRouter>
    </StrictMode>
  </UserContextProvider>
);
